import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { Globe2, ShieldCheck, Activity, Layers, Infinity as Inf } from "lucide-react";

const ICONS = [Globe2, ShieldCheck, Activity, Layers, Inf];

export const Stats = () => {
  const { t } = useLang();
  const s = t.stats;
  return (
    <section data-testid="stats-section" className="relative py-24 md:py-28 border-y border-[var(--border)] bg-[var(--bg-secondary)]/60 overflow-hidden">
      <div className="absolute inset-0 bg-[var(--wine)]/10 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-12">
          <span className="h-px w-10 bg-[var(--gold)]" />
          <span className="overline text-[11px] text-[var(--gold)]">{s.label}</span>
          <h2 className="font-cormorant font-light text-2xl md:text-3xl text-[var(--text-primary)] ml-2">{s.title}</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-12 gap-x-6">
          {s.items.map((it, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`stat-${i}`}
                className="flex flex-col items-start"
              >
                <Icon className="w-6 h-6 text-[var(--gold)] mb-4" strokeWidth={1.3} />
                <div className="font-cormorant text-5xl md:text-6xl text-[var(--text-primary)] leading-none">{it.v}</div>
                <div className="font-outfit font-light text-sm text-[var(--text-secondary)] mt-3">{it.l}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
